import ScorecardContainer from './container'

export default ScorecardContainer
